// skills/fishing/fishingData.js
// Fishing spots and configuration

export const FISH = {
    SAND_SMELT: {
        id: 'sand_smelt',
        name: 'Sand Smelt',
        level: 1,
        xp: 10,
        baseTime: 3000, // 3 seconds base fishing time
        drops: [
            { itemId: 'raw_sand_smelt', weight: 1, quantity: 1 }
        ],
        color: '#ff6b9d'
    },
    SILVER_SPRAT: {
        id: 'silver_sprat',
        name: 'Silver Sprat',
        level: 5,
        xp: 20,
        baseTime: 3500,
        drops: [
            { itemId: 'raw_silver_sprat', weight: 1, quantity: 1 }
        ],
        color: '#c0c0c0'
    },
    BLUEBACK: {
        id: 'blueback',
        name: 'Blueback',
        level: 10,
        xp: 30,
        baseTime: 4000,
        drops: [
            { itemId: 'raw_blueback', weight: 1, quantity: 1 }
        ],
        color: '#4682b4'
    },
    RIVER_CHAR: {
        id: 'river_char',
        name: 'River Char',
        level: 20,
        xp: 50,
        baseTime: 5000,
        drops: [
            { itemId: 'raw_river_char', weight: 1, quantity: 1 }
        ],
        color: '#20b2aa'
    },
    CRIMSON_CHAR: {
        id: 'crimson_char',
        name: 'Crimson Char',
        level: 30,
        xp: 70,
        baseTime: 6000,
        drops: [
            { itemId: 'raw_crimson_char', weight: 1, quantity: 1 }
        ],
        color: '#fa8072'
    },
    SKIPJACK: {
        id: 'skipjack',
        name: 'Skipjack',
        level: 40,
        xp: 80,
        baseTime: 7000,
        drops: [
            { itemId: 'raw_skipjack', weight: 1, quantity: 1 }
        ],
        color: '#483d8b'
    },
    SPINY_LOBSTER: {
        id: 'spiny_lobster',
        name: 'Spiny Lobster',
        level: 50,
        xp: 90,
        baseTime: 8000,
        drops: [
            { itemId: 'raw_spiny_lobster', weight: 1, quantity: 1 }
        ],
        color: '#dc143c'
    },
    BROADBILL: {
        id: 'broadbill',
        name: 'Broadbill',
        level: 60,
        xp: 100,
        baseTime: 9000,
        drops: [
            { itemId: 'raw_broadbill', weight: 1, quantity: 1 }
        ],
        color: '#708090'
    },
    MAKO: {
        id: 'mako',
        name: 'Mako',
        level: 76,
        xp: 110,
        baseTime: 10000,
        drops: [
            { itemId: 'raw_mako', weight: 1, quantity: 1 }
        ],
        color: '#2f4f4f'
    }
};

// Fishing tools/rods
export const RODS = {
    BASIC: {
        id: 'basic_rod',
        name: 'Basic Rod',
        level: 1,
        speedMultiplier: 1.0,
        price: 0 // Starting tool
    },
    PYRESTONE: {
        id: 'pyrestone_rod',
        name: 'Pyrestone Rod',
        level: 5,
        speedMultiplier: 1.15,
        price: 1000
    },
    BLACKIRON: {
        id: 'blackiron_rod',
        name: 'Blackiron Rod',
        level: 15,
        speedMultiplier: 1.3,
        price: 5000
    },
    PALE_SHARD: {
        id: 'pale_shard_rod',
        name: 'Pale Shard Rod',
        level: 30,
        speedMultiplier: 1.5,
        price: 25000
    },
    SKYIRON: {
        id: 'skyiron_rod',
        name: 'Skyiron Rod',
        level: 50,
        speedMultiplier: 1.7,
        price: 100000
    },
    DRAGON: {
        id: 'dragon_rod',
        name: 'Dragon Rod',
        level: 70,
        speedMultiplier: 2.0,
        price: 250000
    }
};

export default {
    FISH,
    RODS
};
